export function getScreenWidth() {

	const doc = document.documentElement;
	return (doc.clientWidth > doc.clientHeight && screen.width > screen.height || doc.clientWidth < doc.clientHeight && screen.width < screen.height) ?
		screen.width : screen.height;
}
